import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'

const GroupTitle = styled.h3`
    color: #c8c8c8;
    font-size: 0.8rem;
    border-bottom: 1px solid #f0f0f0;
    padding-bottom: 0.5rem;
    margin-bottom: 0.5rem;
    text-transform: uppercase;
    font-weight: 500;
`

const Group = ({ id, name, predicate = () => true, children }) => {
    return predicate() ? (
        <div id={id} className="card card--shadow !mb-6">
            <div className="card-body">
                <GroupTitle>{name}</GroupTitle>
                {children}
            </div>
        </div>
    ) : null
}

Group.displayName = 'Group'

Group.propTypes = {
    id: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    predicate: PropTypes.func,
    children: PropTypes.node,
}

export default Group
